import React from "react";
import { Route, Routes } from "react-router";

import AddReferralFormPage from "./form.add.jsx";
import AllReferralFormsPage from "./forms.all.jsx";

const ReferralForms = () => {
  return (
    <Routes>
      <Route element={<AddReferralFormPage />} path="add" />

      <Route element={<AllReferralFormsPage />} path="" />
    </Routes>
  );
};

export default ReferralForms;
